import { defineComponent as _defineComponent } from 'vue'
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { usePlaidLink, preloadPlaid } from 'ah-common-lib/src/plaid';
import IntegrationsListing from './IntegrationsListing.vue';
import { getServices } from '@/app/services';
import { VButton } from 'ah-common-lib/src/common/components';
import { useToast } from 'ah-common-lib/src/toast';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IntegrationsTestComponent',
  setup(__props) {

const reqManager = useRequestManager().manager;
const services = getServices();
const toast = useToast();

const integrationsListing = ref<InstanceType<typeof IntegrationsListing>>();

preloadPlaid();

function addPlaidIntegration() {
  reqManager.cancelAndNew('getPlaidToken', services.integrations.requestPlaidLinkToken()).subscribe((tokenData) => {
    const plaidLink = usePlaidLink({
      token: tokenData.linkToken,
      onExit: () => {
        plaidLink.destroy();
      },
      onSuccess: (publicToken) => {
        reqManager
          .new('exchengePlaidToken', services.integrations.exchangePlaidPublicToken(publicToken))
          .subscribe(() => {
            toast.success('Plaid integration sucessfully added');
            integrationsListing.value?.loadData();
            plaidLink.destroy();
          });
      },
    });

    plaidLink.open();
  });
}

return { __sfc: true,reqManager, services, toast, integrationsListing, addPlaidIntegration, IntegrationsListing, VButton }
}

})